import {StoreConstants} from '../constants/store.constants';
import type {AnyPayloadAction, AppState} from '../models/store.models';
import {storeState} from '../models/store.models';

export function AppReducer(state: AppState = storeState.App, action: AnyPayloadAction): AppState {
  if (action.group !== StoreConstants.StoreGroups.App) return state;

  switch (action.type) {
    case StoreConstants.App.SHOW_3_D_HOME:
      return {
        ...state,
        show3DHome: action.show3DHome
      };

    case StoreConstants.App.CACHE_LOADED:
      return {
        ...state,
        cacheLoaded: action.cacheLoaded
      };

    case StoreConstants.App.MENU_CLICKED$:
      return {
        ...state,
        menuClicked$: action.menuClicked$
      };

    case StoreConstants.App.SHOW_MENU$:
      return {
        ...state,
        showMenu$: action.showMenu$
      };

    case StoreConstants.App.MOUSE_POSITION$:
      return {
        ...state,
        mousePosition$: action.mousePosition$
      };

    case StoreConstants.App.MENU_REFRESH$:
      return {
        ...state,
        menuRefresh$: action.menuRefresh$
      };

    case StoreConstants.App.MENU_ITEMS$$:
      return {
        ...state,
        menuItems$$: action.menuItems$$
      };

    case StoreConstants.App.STATE$:
      return {
        ...state,
        state$: action.state$
      };

    case StoreConstants.App.SETTINGS:
      return {
        ...state,
        settings: action.settings
      };

    case StoreConstants.App.SUBSCRIBERS:
      return {
        ...state,
        subscribers: action.subscribers
      };

    case StoreConstants.App.DB_READY:
      return {
        ...state,
        dbReady: action.dbReady
      };

    case StoreConstants.App.DEVICE_READY:
      return {
        ...state,
        deviceReady: action.deviceReady
      };

    case StoreConstants.App.CACHE_READY:
      return {
        ...state,
        cacheReady: action.cacheReady
      };

    case StoreConstants.App.STORE_READY:
      return {
        ...state,
        storeReady: action.storeReady
      };

    case StoreConstants.App.ACTIVE_DIALOG_ID:
      return {
        ...state,
        activeDialogId: action.activeDialogId
      };

    case StoreConstants.App.LANGUAGE:
      return {
        ...state,
        language: action.language
      };

    case StoreConstants.App.IS_ONLINE:
      return {
        ...state,
        isOnline: action.isOnline
      };

    case StoreConstants.App.NO_IMAGE:
      return {
        ...state,
        noImage: action.noImage
      };

    default:
      return state;
  }
}
